import { render, staticRenderFns } from "./HeaderFront.vue?vue&type=template&id=012c6068"
import script from "./HeaderFront.vue?vue&type=script&lang=js"
export * from "./HeaderFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports